import React from "react";
import { ReactSVG } from "react-svg";
import projects from "Assets/svg/menu/project.svg";
import invoices from "Assets/svg/menu/invoices.svg";
import construction from "Assets/svg/menu/construction.svg";
import contract from "Assets/svg/menu/contract.svg";
import profit from "Assets/svg/menu/profit.svg";
import * as Icons from "react-bootstrap-icons";
import { read } from "Helpers/LocalStorage";
import Wallet from "../Assets/svg/menu/Wallet_nv.svg";

export const ToolBarMenu = {
  dashboard: [
    {
      menu_title: "user_Account",
      menu_icon: <Icons.Person />,
      path: "/dashboard/profile",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: true,
      authorize: true,
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "panel_information",
      menu_icon: <ReactSVG src={Wallet}/>,
      path: "/dashboard/payment/information-panel",
      action: null,
      customClass: "user-panel-information",
      needUpDivider: false,
      needDownDivider: false,
      authorize: read("StypeU") === "1",
      disabled: true,
      useAsBeforeButton: true,
      useAsAfterButton: false,
    },
    {
      menu_title: "support",
      menu_icon: <Icons.ChatLeftText />,
      path: "/dashboard/support",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: true,
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "Manage_User",
      menu_icon: <Icons.People />,
      path: "/dashboard/users",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: read("StypeU") === "1",
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "settings",
      menu_icon: <Icons.Gear />,
      path: "/dashboard/settings",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize:(
        read("settingConstructRules") ? true : false ||
        read("settingDesignerRules") ? true : false ||
        read("settingFactorRules") ? true : false
      ),
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "exit",
      menu_icon: <Icons.DoorOpen />,
      path: null,
      action: "exit",
      customClass: "exit",
      needUpDivider: true,
      needDownDivider: false,
      authorize: true,
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "notification",
      menu_icon: <Icons.Bell />,
      path: "/dashboard/notifications",
      action: "badge",
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: true,
      disabled: true,
      useAsBeforeButton: false,
      useAsAfterButton: true,
    },
    {
      menu_title: "buyAccount",
      menu_icon: <Icons.Bag />,
      path: "/dashboard/payment",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: read("StypeU") === "1",
      disabled: true,
      useAsBeforeButton: true,
      useAsAfterButton: false,
    },
  ],
  design: [
    {
      menu_title: "projects",
      menu_icon: <ReactSVG src={projects} />,
      path: "/dashboard/projects/list",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: true,
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "invoices",
      menu_icon: <ReactSVG src={invoices} />,
      path: "/dashboard/projects/invoices",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: true,
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "contract",
      menu_icon: <ReactSVG src={contract} />,
      path: "/dashboard/projects/contract",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: true,
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "construction",
      menu_icon: <ReactSVG src={construction} />,
      path: "/dashboard/projects/construction",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: !!read("constructCutList") || !!read("constructGlass"),
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
    {
      menu_title: "profit",
      menu_icon: <ReactSVG src={profit} />,
      path: "/dashboard/projects/profit",
      action: null,
      customClass: "",
      needUpDivider: false,
      needDownDivider: false,
      authorize: true,
      disabled: false,
      useAsBeforeButton: false,
      useAsAfterButton: false,
    },
  ],
  informationPanel: [
    {
      menu_title: "activeUsersCount",
      menu_icon: <Icons.People />,
      key: "currentUserCount",
      afterKey: "user",
      button: {
        icon: <Icons.PlusLg />,
        path: "/dashboard/payment/user-increase",
      },
      path: "/dashboard/payment/user-increase",
      disabled: false,
      needUpDivider: false,
      needDownDivider: false,
    },
    {
      menu_title: "walletBalance",
      menu_icon: <Icons.Wallet />,
      key: "credit",
      afterKey: "moneyUnit",
      button: {
        icon: <Icons.PlusLg />,
        path: "/dashboard/payment/wallet",
      },
      path: "/dashboard/payment/wallet",
      disabled: false,
      needUpDivider: false,
      needDownDivider: true,
    },
    {
      menu_title: "validityPeriod",
      menu_icon: null,
      key: "end_date",
      afterKey: "",
      button: null,
      path: "/dashboard/payment/information-panel",
      disabled: false,
      needUpDivider: false,
      needDownDivider: false,
    },
    {
      menu_title: "currentPeriod",
      menu_icon: null,
      key: "currentPeriod",
      afterKey: "",
      button: null,
      path: "/dashboard/payment/information-panel",
      disabled: false,
      needUpDivider: false,
      needDownDivider: false,
    },
    {
      menu_title: "paymentsHistory",
      menu_icon: null,
      key: "",
      afterKey: "",
      button: null,
      path: "/dashboard/payment/histories",
      disabled: false,
      needUpDivider: false,
      needDownDivider: false,
    },
  ],
};
